import React, { useCallback, useEffect, useRef, useState } from "react";
import ReactPlayer from 'react-player';
import { useParams, useHistory } from "react-router-dom";
import Footer from "../../components/website/Footer";
import Header from "../../components/website/Header";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDoubleDown, faAngleDoubleUp } from '@fortawesome/free-solid-svg-icons';
import { PayPalScriptProvider, PayPalButtons, BraintreePayPalButtons } from "@paypal/react-paypal-js";
import $ from "jquery";
import "magnific-popup";
import "swiper/css";
import { Swiper, SwiperSlide } from 'swiper/react';
import api from "../../api/endpoints/events.js";
import storage from "../../firebase";
import { PDFViewer, pdf } from '@react-pdf/renderer';
import InvoicePDF from "../../components/InvoicePDF";
import Popup from "../../components/Popup";
import { NotificationManager } from 'react-notifications';
import { ThreeDots } from "react-loader-spinner";
import NotFound from "./NotFound";
import getPartnerUrl from "../../components/getPartnerUrl";
import PersonalPhotos from "../../components/PersonalPhotos";

import {
  listAll,
  ref as storageRef,
  getDownloadURL,
} from "firebase/storage";
import axios from "axios";
import keyImage1 from "../../assets/images/key1.png";
import keyImage2 from "../../assets/images/key2.png";
import keyImage3 from "../../assets/images/key3.png";
import keyImage4 from "../../assets/images/key4.png";
import keyImage5 from "../../assets/images/key5.png";
import keyImage6 from "../../assets/images/key6.png";

// import Rodal from "rodal";
import Modal from "../../components/Modal";

// include styles
import "rodal/lib/rodal.css";

// Import Swiper styles
import "swiper/css";

import { register } from "swiper/element/bundle";
import Breadcrumbs from "../../components/Breadcrumbs";
// import Timer from "../../components/Timer";
register();

function SingleConference() {
  const marqueeRef = useRef();
  const [logos, setLogos] = useState([]);

  // const myEventList = ["7TH ANNUAL INHALATION & RESPIRATORY DRUG DELIVERY CONFERENCE"];
  const myEventListButtons = ["5TH ANNUAL ADVANCED PLASTICS RECYCLING HYBRID CONFERENCE",
    "3RD ANNUAL NURSE MANAGEMENT & PERSPECTIVES ON NURSING LEADERSHIP HYBRID CONFERENCE",
    "ADVANCED PLASTICS RECYCLING CONFERENCE AND CHRISTMAS INDUSTRY CELEBRATION", "5TH ANNUAL BTEL SUMMIT"];

  const myEventSpecific = ["ADVANCED PLASTICS RECYCLING CONFERENCE AND CHRISTMAS INDUSTRY CELEBRATION",
    "4TH ANNUAL NURSE MANAGEMENT & PERSPECTIVES ON NURSING LEADERSHIP CONFERENCE",
    "5TH ANNUAL EXECUTIVE & PERSONAL ASSISTANT CONFERENCE"];

  const myEventVideo = ["INTERNATIONAL HRD SUMMIT"];

  const myEventDescription = ["5TH ANNUAL EXECUTIVE & PERSONAL ASSISTANT CONFERENCE"]

  const eventBTEL = ["5TH ANNUAL BTEL SUMMIT & EXHIBITION"]

  const  eventInhalation = ["7TH ANNUAL INHALATION & RESPIRATORY DRUG DELIVERY CONFERENCE AND CHRISTMAS INDUSTRY CELEBRATION"]

  const eventPA = ["5TH ANNUAL EXECUTIVE & PERSONAL ASSISTANT CONFERENCE"]
  const eventAdvancedPlastic = ["ADVANCED PLASTICS RECYCLING CONFERENCE AND CHRISTMAS INDUSTRY CELEBRATION"]

  const eventLogistics = ["LOGISTICS TECH SUMMIT"]

  const myEventBopap = ["5TH ANNUAL EXECUTIVE & PERSONAL ASSISTANT CONFERENCE", "ADVANCED PLASTICS RECYCLING CONFERENCE AND CHRISTMAS INDUSTRY CELEBRATION"]
  const allevents = ["5TH ANNUAL EXECUTIVE & PERSONAL ASSISTANT CONFERENCE"];

  const swiperRef = useRef(null);

  const handleImageClick = (index) => {
    console.log('Clicked on image with index:', index);
    const mainSwiper = document.getElementById('mainSwiper');
    if (mainSwiper) {
      mainSwiper.swiper.slideTo(index);
    }};

  const handleImageClickhotel = (index) => {
    console.log('Clicked on image with index:', index);
    const hotelSwiper = document.getElementById('hotelSwiper');
    if (hotelSwiper) {
      hotelSwiper.swiper.slideTo(index);
    }};
  const handleImageClickpartner = (index) => {
    console.log('Clicked on image with index:', index);
    const partnersSwiper = document.getElementById('partnersSwiper');
    if (partnersSwiper) {
      partnersSwiper.swiper.slideTo(index);
    }};


  const invoiceData = {
    invoiceNumber: 'INV123',
    date: '2023-08-24',
    // Add more data as needed
  };
  const { id } = useParams();
  const [conference, setConference] = useState([]);
  const [galleryImages, setGalleryImages] = useState([]);
  const [hotelImages, setHotelsImages] = useState([]);
  const [showAll, setShowAll] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [activeSlide, setActiveSlide] = useState(0);
  const [isValidId, setIsValidId] = useState(true);
  const [delegatePopupOpened, setDelegatePopupOpened] = useState(false);
  // const [isBankTransferAvailable, setIsBankTransferAvailable] = useState(false);

  const agendaInitState = {
    conferenceName: "",
    fullName: "",
    email: "",
    phone: "",
    job: "",
    company: "",
  };

  const bankInitState = {
    invoiceNum: "DEFAULT_NUMBER",
    conferenceName: "",
    firstName: "",
    lastName: "",
    email: "",
    job: "",
    company: "",
    address: "",
    city: "",
    vat: "",
    phone: "",
    ticket: { name: "", price: "" },
    promo: "",
  };

  const [agenda, setAgenda] = useState(agendaInitState);
  const [bank, setBank] = useState(bankInitState);
  const [currentType, setCurrentType] = useState(null);
  const handleAgenda = (event) => {
    const { name, value } = event.target;
    setAgenda((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  const handleBank = (event) => {
    const { name, value } = event.target;
    const [paymentName, price] = value.split(':');
    setBank((prevState) => ({
      ...prevState,
      [name]: value,
      conferenceName: conference.eventName,
      ticket: { name: paymentName, price },
    }));
  };
  const handleCheckboxChange = (e) => {
    setIsChecked(e.target.checked);
  }

  const changeButton = (e) => {
    console.log(e.target.checked);
    setIsChecked(e.target.checked);
  };

  function handleSubmit(e) {
    e.preventDefault(); // Предотвращаем стандартное поведение формы (перезагрузку страницы)

    // Выполняем логику обработки данных формы
    // Например, отправка данных на сервер или другие действия

    // После обработки данных, вы можете перенаправить пользователя или выполнить другие действия
  }
  function handleFormSubmit(e) {
    e.preventDefault(); // Предотвращаем стандартное поведение формы (перезагрузку страницы)

    // Выполняем логику отправки сообщения в Slack
    postMessageToSlack(e, "agenda");

    // Выполняем логику обработки данных формы или другие действия
    handleSubmit(e);
  }
  const keyImages = [
    keyImage1,
    keyImage2,
    keyImage3,
    keyImage4,
    keyImage5,
    keyImage6,
  ];

  const createOrder = (data, actions, price) => {
    return actions.order.create({
      purchase_units: [
        {
          amount: {
            value: price, // Use the passed price value
          },
        },
      ],
    });
  };

  const onApprove = (data, actions) => {
    // This function is called when the payment is approved
    return actions.order.capture().then(details => {
      console.log('Payment successful', details);
    });
  };

  const fetchImages = async (listRef) => {
    try {
      const result = await listAll(listRef);
      const urlPromises = result.items.map(async (imageRef) => {
        const imageUrl = await getDownloadURL(imageRef);
        return imageUrl;
      });
      return Promise.all(urlPromises);
    } catch (error) {
      console.log('Error fetching images: ', error);
      throw error;
    }
  };

  const generateInvoice = async (bank, invoiceNum) => {
    try {
      console.log('bank before generate pdf: ', bank);
      const pdfBlob = await InvoicePDF(bank, invoiceNum);
      return pdfBlob; // Return the FormData containing the PDF
    } catch (error) {
      console.error('Error generating invoice:', error);
      throw error; // Re-throw the error to be handled in the higher-level function
    }
  };

  const sendToAPI = async (type, url) => {

    let bankName = {
      "Conference": bank.conferenceName,
      "First Name": bank.firstName,
      "Last Name": bank.lastName,
      "Email": bank.email,
      "Job Title": bank.job,
      "Company": bank.company,
      "Company Address": bank.address,
      "City": bank.city,
      "VAT": bank.vat,
      "Phone": bank.phone,
      "Ticket Type": { "Ticket Name": bank.ticket.name, "Ticket Price": bank.ticket.price },
      "Promo": bank.promo
    }

    const invoiceNumber = await api.get(`${url}User/invoice/get-number`);
    const inNum = invoiceNumber.data.toString();
    console.log('invoice number: ', inNum);
    setBank((prevState) => ({
      ...prevState,
      invoiceNum: inNum,
    }));

    setIsLoading(true);

    try {

      const pdfBlob = await generateInvoice(bank, inNum);
      const formData = new FormData();
      formData.append('data', JSON.stringify(bankName));
      formData.append('pdfFile', pdfBlob, 'invoice.pdf');

      console.log('bankData is: ', bankName);

      const response = await axios.post(`${url}User/slack-pdf`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      console.log('response from endpoint:', response);
      setIsModalOpen(false);
      document.querySelector(".header").style.zIndex = "3";
      if(type === "agenda") {
        NotificationManager.success('Thank you for your request!\n', 'Success', 5000);
      }
      else {
        NotificationManager.success('Thank you for your registration!\n' +
            'The invoice has been sent to your email.', 'Success', 5000);
      }
      setIsLoading(false);
    } catch (error) {
      console.error('Error sending request to API:', error);
      setIsLoading(false);
      // Handle error as needed
    }
  };


  const fetchPdf = async (eventId) => {
    try {
      const pdfRef = storageRef(storage, `gs://sns-cz.appspot.com/Agenda/${eventId}.pdf`);
      const pdfUrl = await fetchPdfUrl(pdfRef);
      return pdfUrl;
    } catch (error) {
      console.log('Error fetching PDF: ', error);
    }
  };

  const fetchPdfUrl = async (pdfRef) => {
    try {
      const pdfUrl = await getDownloadURL(pdfRef);
      return pdfUrl;
    } catch (error) {
      throw error;
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        window.scrollTo(0, 0);

        const { data } = await api.get(`/Event/get-event-by-slug/${id}`);
        if(data.endDate == null) {
          setIsValidId(false);
          return;
        }
        setConference(data);
        console.log('Conference id: ', data);

        setAgenda((prevState) => ({
          ...prevState,
          conferenceName: data.eventName,
        }));

        const conferenceGalleryListRef = storageRef(storage, `gs://sns-cz.appspot.com/Images/${data.id}`);
        const hotelId = data.hotels[0]?.id;
        const hotelGalleryListRef = storageRef(storage, `gs://sns-cz.appspot.com/Images/${hotelId}`);

        const conferenceGalleryImages = await fetchImages(conferenceGalleryListRef);
        const hotelGalleryImages = await fetchImages(hotelGalleryListRef);

        setGalleryImages(conferenceGalleryImages);
        setHotelsImages(hotelGalleryImages);

        console.log('Gallery images: ', galleryImages);
      } catch (error) {
        console.log('Error fetching data: ', error);
        setIsValidId(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const marqueeElement = marqueeRef.current;

    if (marqueeElement) {
      const handleAnimationEnd = () => {
        // Когда анимация завершится, вы можете сделать что-то, если это необходимо
      };

      marqueeElement.addEventListener('animationend', handleAnimationEnd);

      // Очистка слушателя событий при размонтировании компонента
      return () => {
        marqueeElement.removeEventListener('animationend', handleAnimationEnd);
      };
    }

    return undefined;
  }, [marqueeRef]);

  function getSponsorType(sponsorType) {
    switch (sponsorType) {
      case 0:
        return <span>Diamond</span>;
      case 1:
        return <span>Platinum</span>;
      case 2:
        return <span>Gold</span>;
      case 3:
        return <span>Silver</span>;
      case 4:
        return <span>Keynote</span>;
      case 5:
        return <span>Exhibition</span>;
      case 6:
        return <span>Online Silver</span>;
        // Добавьте другие случаи по мере необходимости
      default:
        return <span>Другой тип спонсора</span>;
    }
  }
  useEffect(() => {
    $(".popup-with-zoom-anim").magnificPopup({
      type: "inline",
      fixedContentPos: false,
      fixedBgPos: true,
      overflowY: "auto",
      closeBtnInside: false,
      closeMarkup:
          '<button title="%title%" type="button" class="mfp-close close-button"> <div class="line1"></div> <div class="line2"></div> </button>',
      preloader: false,
      midClick: true,
      removalDelay: 300,
      autoOpen: false,
      mainClass: "my-mfp-fade-in",
      callbacks: {
        close: function () {
          $("html").removeClass("mfp-open");
        },
      },
    });
  });

  useEffect(() => {
    const overlay = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          const popUps = document.querySelector('.modal, .mfp-bg');
          if (popUps) {
          } else {
            document.body.style.overflow = 'auto';
          }
        }
      }
    });

    overlay.observe(document.body, { childList: true, subtree: true });

    return () => overlay.disconnect();
  }, []);

  const formateDate = (date) => {
    if (!date.startDate || !date.endDate) {
      return '';
    }

    const { startDate, endDate } = date;
    const formattedDate = new Date(startDate);
    const [startDay, endDay] = [
      formattedDate.getDate(),
      new Date(endDate).getDate(),
    ];
    return ` ${formattedDate.toLocaleString("en-US", { month: "long" })}
     ${startDay} -
     ${endDay}, ${new Date(endDate).getFullYear()}`;
  };

  const postMessageToSlack = async (e, type) => {
    e.preventDefault();
    let url = '';
    if (window.location.hostname === 'localhost') {
      url = 'https://api.bcf-events.com/';
      // url = 'https://localhost:7264/';
    }
    if (window.location.hostname === 'green-desert-021865b10.3.azurestaticapps.net'
        || window.location.hostname === 'brave-dune-00ae5aa10.3.azurestaticapps.net'
        || window.location.hostname === 'new.bcf-events.com'
        || window.location.hostname === 'bcf-events.com'
    ) {
      url = 'https://api.bcf-events.com/';
    }

    try {
      let agendaName = {
        "Conference": agenda.conferenceName,
        "Full Name": agenda.fullName,
        "Email": agenda.email,
        "Phone": agenda.phone,
        "Job Title": agenda.job,
        "Company": agenda.company,
      }

      console.log('URL for API:', url); // Добавляем лог для проверки URL

      if (type === "agenda") {
        setAgenda(agendaInitState);
        console.log('Agenda Name:', agendaName); // Добавляем лог для проверки agendaName
        const response = await axios.post(`${url}User/slack/${type}`, agendaName);
        console.log('Response from endpoint:', response); // Добавляем лог для ответа от API

        const anchor = document.createElement("a");
        const urlpdf = await fetchPdf(conference.id);
        anchor.href = urlpdf;
        anchor.download = "agenda.pdf";
        anchor.style.display = "none";
        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);
      } else {
        await sendToAPI(type, url);
      }
    } catch (error) {
      console.error("Error sending message to Slack:", error);
    }
  };

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = (type) => {
    setCurrentType(type);
    setIsModalOpen(true);
    if (type === "delegate") {
      setDelegatePopupOpened(true);
    }
    document.querySelector(".header").style.zIndex = "1";
  };
  useEffect(() => {
    if (isModalOpen) {

    }
  }, [isModalOpen]);
  const handleCloseModal = () => {
    setIsModalOpen(false);
    document.querySelector(".header").style.zIndex = "3";
  };

  useEffect(() => {
    const listItems = document.querySelectorAll('.thisStyle, .andThisStyle');

    listItems.forEach(item => {
      const line = item.querySelector('.line-breadcrumbs');
      if(line) {
        line.style.width = item.offsetWidth + 'px';
      }
    });
  }, []);

  const [diffInSeconds, setDiffInSeconds] = useState(null);

  useEffect(() => {
    const intervalId = setInterval(() => {
      const now = new Date();
      const endDate = new Date(conference.endDate);

      const diffInMilliseconds = endDate.getTime() - now.getTime();
      const calculatedDiffInSeconds = Math.floor(diffInMilliseconds / 1000);

      setDiffInSeconds(calculatedDiffInSeconds * 1000);
    }, 1000);

    return () => clearInterval(intervalId);
  }, [conference.endDate]);

  if (!isValidId) {
    return <NotFound />;
  }
  const scrollToSection = (id, offset) => {
    const element = document.getElementById(id);
    if (element) {
      const yOffset = offset || 0; // Смещение, если не указано, будет равно 0
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  };
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 750); // Устанавливаем состояние isSticky в true, если прокрутка больше 500 пикселей
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // const handleOpenBankTransfer = () => {
  //   NotificationManager.error('Thank you for your request! This payment type does not work at this time. Use another one or write to us.', 'We are sorry', 5000);
  // }

  return (
      <div>
        <Header />
        <div>
          {myEventBopap.includes(conference.eventName) && (

              <Popup handleOpenModal={handleOpenModal} delegatePopupOpened={delegatePopupOpened} />

          )}
        </div>
        <main>
          {/* <PDFViewer width="100%" height={500}>
        <InvoicePDF invoiceData={invoiceData} />
      </PDFViewer> */}
          <section name="main">
            <div className="main-container">
              <div
                  className="background-single"
                  style={{
                    backgroundImage: `url(${conference.eventImage})`,
                  }}
              ></div>
              <div className="background-block">
                <div className="container" id="main">
                  <div className="breadcrumbs">
                    <ul>
                      <li className="andThisStyle">
                        <Link className="conference-link" to="/">
                          MAIN
                        </Link>
                      </li>
                      <li className="thisStyle">{conference.eventName}</li>
                    </ul>
                    <Breadcrumbs conferenceName={conference.eventName} />
                  </div>
                  <div className="title">
                    <h1>{conference.eventName}</h1>
                    <span className="line-title"></span>
                    <span className="mobile-title-line"></span>
                    <p>
                      {formateDate(conference)} {conference.location !== 'Online' && (
                        <>
                          {conference.location}
                          <h3>
                            {conference.hotels && conference.hotels.length > 0 ?
                                conference.hotels.map((hotel) => hotel.hotelName).join(', ') :
                                "To be announced soon"
                            }
                          </h3>
                        </>
                    )}
                      {/* Добавьте обработку для Timer здесь, если нужно */}
                    </p>
                  </div>
                  {eventBTEL.includes(conference.eventName) && (
                  <div className="second_title">
                    <ul className="second_ditle_list">
                      <h3>Summit Features:</h3>
                      <li>Workshop</li>
                      <li>Networking Activities</li>
                      <li>Event Application</li>
                    </ul>
                  </div>
                      )}
                  {eventInhalation.includes(conference.eventName) && (
                      <div className="second_title">
                        <ul className="second_ditle_list">
                          <h3>Conference Features:</h3>
                          <li>Icebreaker Session</li>
                          <li>Networking Activities</li>
                          <li>Event Application</li>
                        </ul>
                      </div>
                  )}
                  {eventPA.includes(conference.eventName) && (
                      <div className="second_title">
                        <ul className="second_ditle_list">
                          <h3>Conference Features:</h3>
                          <li>Certified pre-conference workshop by David Svoboda, Canva Verified Expert and TEDx speaker</li>
                          <li>2-day conference access</li>
                          <li>Lunches</li>
                          <li>Cocktail reception</li>
                          <li>Prosecco round table</li>
                          <li>Post Documentation</li>
                          <li>Recording</li>
                        </ul>
                      </div>
                  )}
                  {eventLogistics.includes(conference.eventName) && (
                      <div className="second_title">
                        <ul className="second_ditle_list">
                          <h3>Summit Features:</h3>
                          <li>Icebreaker Session</li>
                          <li>Networking Activities</li>
                          <li>Event Application</li>
                        </ul>
                      </div>
                  )}
                  {eventAdvancedPlastic.includes(conference.eventName) && (
                      <div className="second_title">
                        <ul className="second_ditle_list">
                          <h3>Conference Features:</h3>
                          <li>Icebreaker Session</li>
                          <li>Networking Activities</li>
                          <li>Event Application</li>
                        </ul>
                      </div>
                  )}
                  <div className="action-block block-icons-div">
                    <ul>
                      {allevents.includes(conference.eventName) && (
                      <li onClick={() => handleOpenModal("agenda")} className="download-agenda">
                      <span className="icon">
                        <img
                            src={require("../../assets/images/adgenda.png")}
                            alt=""
                        />
                      </span>
                        <p>
                          DOWNLOAD AGENDA
                        </p>
                      </li> )}
                      {allevents.includes(conference.eventName) && (
                      <span className="line new-line-conference"></span>
                          )}

                      <li
                          className="become-delegate"
                          onClick={() => handleOpenModal("delegate")}
                      >
                      <span className="icon">
                        <img
                            src={require("../../assets/images/delegate.png")}
                            alt=""
                        />
                      </span>
                        <p>REGISTER NOW</p>
                      </li>
                      {conference.linkedInUrl != null && (
                          <>
                            <span className="line new-line-conference"></span>
                            <li className="event-page">
                              <a className="popup-with-zoom-anim2" target="_blank" href={conference.linkedInUrl}>
                        <span className="icon">
                          <img
                              src={require("../../assets/images/event.png")}
                              alt=""
                          />
                        </span>
                                <p>EVENT PAGE</p>
                              </a>
                            </li>
                          </>
                      )}
                      <span className="line new-line-conference"></span>
                      <li className="become-sponsor">
                        {conference.confExpensivness === 1 ? (
                            <Link className="popup-with-zoom-anim2" to="/sponsorship">
                          <span className="icon">
                            <img src={require("../../assets/images/sponsor.png")} alt="" />
                          </span>
                              <p>BECOME A SPONSOR</p>
                            </Link>
                        ) : (
                            <Link className="popup-with-zoom-anim2" to="/secondsponsorship">
                          <span className="icon">
                            <img src={require("../../assets/images/sponsor.png")} alt="" />
                          </span>
                              <p>BECOME A SPONSOR</p>
                            </Link>
                        )}
                      </li>
                    </ul>
                    <Modal
                        types="delegate"
                        currentType={currentType}
                        isOpen={isModalOpen}
                        onClose={handleCloseModal}
                    >
                      <div
                          id="delegate-dialog"
                          className=" special-style"
                      >
                        <div className="popup-container"></div>
                        <Link
                            className="conference-link conference-data-link"
                            to={`/stripe/${conference.slug}`}
                        >
                          <div className="popup-item item-1">
                            <span className="text-popup">CREDIT CARD</span>
                          </div>
                        </Link>
                        <div
                            className="popup-item item-2"
                            onClick={() => handleOpenModal("pay-pal")}
                        >
                          <span className="text-popup">PAYPAL</span>
                        </div>
                        <div
                            className="popup-item item-3"
                            onClick={() => handleOpenModal("bank-transfer")}
                            // className="popup-item item-3 disabled"
                            // onClick={() => handleOpenBankTransfer("bank-transfer")}
                        >
                          <span className="text-popup">BANK TRANSFER</span>
                        </div>

                      </div>
                    </Modal>
                  </div>

                  <Modal
                      types="agenda"
                      currentType={currentType}
                      isOpen={isModalOpen}
                      onClose={handleCloseModal}
                  >
                    <div className="white-square">
                      <div className="scroll-container-wrapper">
                        <div className="scroll-container">
                          <form
                              className="form-bank"
                              onSubmit={(e) => handleFormSubmit(e)}>
                            <div className="form-group">
                              <label
                                  htmlFor="firstName"
                                  className="first-name-class"
                              >
                                Full Name*
                              </label>
                              <input
                                  type="text"
                                  id="first-name-input"
                                  name="fullName"
                                  required
                                  value={agenda.firstName}
                                  onChange={(e) => handleAgenda(e)}
                              />
                            </div>
                            <div className="form-group">
                              <label htmlFor="email">Email*</label>
                              <input
                                  type="email"
                                  id="email-input"
                                  name="email"
                                  required
                                  value={agenda.email}
                                  onChange={(e) => handleAgenda(e)}
                              />
                            </div>
                            <div className="form-group">
                              <label htmlFor="phone">Phone*</label>
                              <input
                                  type="number"
                                  id="phone"
                                  name="phone"
                                  required
                                  value={agenda.phone}
                                  onChange={(e) => handleAgenda(e)}
                              />
                            </div>
                            <div className="form-group">
                              <label htmlFor="job-title">Job Title*</label>
                              <input
                                  type="text"
                                  id="job-title-input"
                                  name="job"
                                  required
                                  value={agenda.job}
                                  onChange={(e) => handleAgenda(e)}
                              />
                            </div>
                            <div className="form-group">
                              <label htmlFor="company-name">Company Name*</label>
                              <input
                                  type="text"
                                  id="company-name-input"
                                  name="company"
                                  required
                                  value={agenda.company}
                                  onChange={(e) => handleAgenda(e)}
                              />
                            </div>
                            <button type="submit" className="canister-button">
                              { isLoading ? <ThreeDots  height="40" width="40" color="white" /> : "Request" }
                            </button>
                          </form>
                        </div>
                      </div>
                    </div>
                  </Modal>

                  <Modal
                      types="bank-transfer"
                      currentType={currentType}
                      isOpen={isModalOpen}
                      onClose={handleCloseModal}
                  >
                    <div className="bank-style  special-style">
                      <div className="white-square">
                        <div className="scroll-container-wrapper">
                          <div className="scroll-container add-mobile-wrapper">

                            <form
                                className="form-bank"
                                onSubmit={(e) =>
                                    postMessageToSlack(e, "bank-transfer")
                                }
                            >
                              <div className="form-group">
                                <label
                                    htmlFor="first-name"
                                    className="first-name-class"
                                >
                                  First Name*
                                </label>
                                <input
                                    type="text"
                                    id="first-name"
                                    name="firstName"
                                    required
                                    value={bank.firstName}
                                    onChange={(e) => handleBank(e)}
                                />
                              </div>
                              <div className="form-group">
                                <label htmlFor="last-name">Last Name*</label>
                                <input
                                    type="text"
                                    id="last-name"
                                    name="lastName"
                                    required
                                    value={bank.lastName}
                                    onChange={(e) => handleBank(e)}
                                />
                              </div>
                              <div className="form-group">
                                <label htmlFor="email">Email*</label>
                                <input
                                    type="email"
                                    id="email"
                                    name="email"
                                    required
                                    value={bank.email}
                                    onChange={(e) => handleBank(e)}
                                />
                              </div>
                              <div className="form-group">
                                <label htmlFor="job-title">Job Title*</label>
                                <input
                                    type="text"
                                    id="job-title"
                                    name="job"
                                    required
                                    value={bank.job}
                                    onChange={(e) => handleBank(e)}
                                />
                              </div>
                              <div className="form-group">
                                <label htmlFor="company-name">
                                  Company Name*
                                </label>
                                <input
                                    type="text"
                                    id="company-name"
                                    name="company"
                                    required
                                    value={bank.company}
                                    onChange={(e) => handleBank(e)}
                                />
                              </div>
                              <div className="form-group">
                                <label htmlFor="company-address">
                                  Company Address*
                                </label>
                                <input
                                    type="text"
                                    id="company-address"
                                    name="address"
                                    required
                                    value={bank.address}
                                    onChange={(e) => handleBank(e)}
                                />
                              </div>
                              <div className="form-group">
                                <label htmlFor="city">City*</label>
                                <input
                                    type="text"
                                    id="city"
                                    name="city"
                                    required
                                    value={bank.city}
                                    onChange={(e) => handleBank(e)}
                                />
                              </div>
                              <div className="form-group">
                                <label htmlFor="vat">
                                  VAT of the company (only for EU company)
                                </label>
                                <input
                                    type="text"
                                    id="vat"
                                    name="vat"
                                    value={bank.vat}
                                    onChange={(e) => handleBank(e)}
                                />
                              </div>
                              <div className="form-group">
                                <label htmlFor="phone">Phone*</label>
                                <input
                                    type="number"
                                    id="phone"
                                    name="phone"
                                    required
                                    value={bank.phone}
                                    onChange={(e) => handleBank(e)}
                                />
                              </div>
                              <div className="form-group">
                                <label htmlFor="promo">Promo</label>
                                <input
                                    type="text"
                                    id="promo"
                                    name="promo"
                                    value={bank.promo}
                                    onChange={(e) => handleBank(e)}
                                />
                              </div>
                              <div className="form-group">
                                <label htmlFor="ticket-type">Ticket Type*</label>
                                <select
                                    id="ticket-type"
                                    name="ticket"
                                    required
                                    value={bank.ticket.name !== "" ? `${bank.ticket.name}:${bank.ticket.price}` : ""}
                                    onChange={(e) => handleBank(e)}
                                >
                                  <option value="">Select one</option>
                                  {conference?.payPalPayments?.map((payment, index) => (
                                      <option key={`option-${index}`} value={`${payment.paymentName}:${payment.price}`}>
                                        {`${payment.paymentName}: ${"€" + payment.price}`}
                                      </option>
                                  ))}
                                </select>
                              </div>
                              <div className="form-group1">
                                <label class="galochka">
                                  <input
                                      type="checkbox"
                                      className="custom-checkbox"
                                      onChange={handleCheckboxChange}
                                      checked={isChecked}
                                  />
                                  I agree with&nbsp;<a href="https://bcf-events.com/terms">Terms and Conditions</a>
                                </label>
                              </div>
                              <button
                                  type="submit"
                                  className={`register-button ${isChecked ? 'active' : 'inactive'}`}
                                  disabled={!isChecked}
                              >
                                { isLoading ? <ThreeDots  height="40" width="40" color="white" /> : "Register"}
                              </button>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Modal>
                  <Modal
                      types="pay-pal"
                      currentType={currentType}
                      isOpen={isModalOpen}
                      onClose={handleCloseModal}
                  >
                    <div
                        //id="paypal-dialog"
                        //className="zoom-anim-dialog mfp-hide my-custom-popup-styles"
                    >
                      {conference.payPalPayments && conference.payPalPayments.length > 0 && (
                          <div className="paypal-square">
                            <div className="scroll-container-wrapper">
                              {/*<div className="scroll-container">*/}
                              {/*</div>*/}
                              <div className="scroll-container">
                                {conference?.payPalPayments?.map((pay) => (
                                    <div key={pay.id} className="paypal-wrapper">
                                      <div>
                                        <h4>{pay.paymentName}</h4>
                                        <p className="price-paypal">1 x {pay.price} EUR</p>
                                      </div>
                                      <div className="paypal-width">
                                        <PayPalScriptProvider options={{ clientId: "AYoVCFKvcXHDj0pcFTGhsqYjaH4dJnWibwLvIda5WAlELIXpQcqUM_y37SpKrdhB_3ts2RiH6kpYwf1i", currency: "EUR" }}>
                                          <PayPalButtons
                                              createOrder={(data, actions) => createOrder(data, actions, pay.price)}
                                              onApprove={onApprove}
                                              style={{ layout: "horizontal" }}
                                          />
                                        </PayPalScriptProvider>
                                      </div>
                                    </div>
                                ))}
                              </div>
                            </div>
                          </div>
                      )}
                    </div>
                  </Modal>
                </div>
              </div>

              <nav className={`page-navigation-container ${isSticky ? 'sticky' : ''}`}>
                <ul className="page-navigation">
                  <li><h2>Page Navigation</h2></li>
                  <li><a onClick={() => scrollToSection('main')}>Register now</a></li>
                  {conference.speakers && conference.speakers.length > 0 && (
                      <li><a onClick={() => scrollToSection('speakers', -175)}>Speakers</a></li>  )}
                  <li><a onClick={() => scrollToSection('about', -175)}>Conference overview</a></li>
                  <li><a onClick={() => scrollToSection('key', -175)}>Key points</a></li>
                  {conference.sponsors && conference.sponsors.length > 0 && (
                      <li><a onClick={() => scrollToSection('sponsors', -175)}>Sponsors</a></li> )}
                  <li><a onClick={() => scrollToSection('gallery', -175)}>Gallery</a></li>
                  {conference.hotels && conference.hotels.length > 0 && (
                      <li><a onClick={() => scrollToSection('venue', -175)}>Venue</a></li>  )}
                  <li><a onClick={() => scrollToSection('contact', -175)}>Contact us</a></li>
                </ul>
              </nav>
            </div>
          </section>

          {conference.speakers && conference.speakers.length > 0 && (
              <section>
                <div className="marquee-container">
                  <ul className="marquee">
                    {conference.speakers.map((speaker, index) => (
                        speaker.logo && speaker.logo.length > 0 && (
                            <li key={speaker.id || index} className="marquee-item">
                              <div className="marquee-item-wrapper">
                                <img src={speaker.logo} alt={`Logo ${index}`} />
                              </div>
                            </li>
                        )
                    ))}
                  </ul>
                </div>
              </section>
          )}

          {conference.speakers && conference.speakers.length > 0 && (
              <section className="section-speakers" id="speakers">
                <div className="container">
                  <h2 className="title-about title-about-single"> {myEventSpecific.includes(conference.eventName)
                      ? "Advisory Board and Speakers"
                      : "Speakers"
                  }</h2>
                  <div className="line-container">
                    <span className="line-about"></span>
                  </div>
                  {myEventDescription.includes(conference.eventName) && (
                      <p className="description-special add-about"> The Advisory Board is composed of experienced and
                        distinguished thought leaders from various industries. This group plays a crucial role in advising
                        the BCF on the strategic direction of the conference program, offering recommendations for speakers,
                        shaping content themes, and providing valuable insights into the research community. </p>

                  )}
                  <ul className={myEventSpecific.includes(conference.eventName) ? "grid-container-custom" : "grid-container"}>
                    {conference.speakers &&
                        conference.speakers.map((speaker) => (
                            <li className="grid-item" key={speaker.id}>
                              <div>
                                <a className={`popup-with-zoom-anim ${myEventSpecific.includes(conference.eventName) ?
                                    'speaker-style-special' : 'speaker-style'}`}
                                   href={`#small-dialog-${speaker.id}`}
                                >
                                  <img
                                      src={`${speaker.profileImage}`}
                                      alt=""
                                      className="flip-img mobile-image"
                                  />
                                </a>
                              </div>
                              <p className={myEventSpecific.includes(conference.eventName) ? "name-special" : "name"}>{speaker.fullName}</p>
                              <p className={myEventSpecific.includes(conference.eventName) ? "position-special" : "position"}>{speaker.position}</p>
                              {myEventVideo.includes(conference.eventName) && (
                                  <p className="company">
                                    <a href={speaker.speakersUrlLogo}  style={{ color: '#00005A', fontWeight: 'bold', textDecoration: 'none' }}>
                                      {speaker.company}
                                    </a>
                                  </p>)}
                              <a href={speaker.speakersUrlLogo} target="_blank">
                                <img
                                    className="logo-company"
                                    src={speaker.logo}
                                    alt=""
                                />
                              </a>
                              <div className="scroll-container-wrapper">
                                <div id={`small-dialog-${speaker.id}`} className="zoom-anim-dialog mfp-hide my-custom-popup-style scroll-container">
                                  <div className="popup-flex">
                                    <img className={`popup-img ${myEventSpecific.includes(conference.eventName) ? 'popup-img-special' : ''}`} src={speaker.profileImage} alt="" />
                                    <div className="popup-direction">
                                      <p className="name mobile-name">{speaker.fullName}</p>
                                      <p className="position mobile-position">
                                        {speaker.position}
                                      </p>
                                      <p className="company mobile-company">
                                        <a href={speaker.speakersUrlLogo} style={{ color: '#00005A', fontWeight: 'bold', textDecoration: 'underline' }}>
                                          {speaker.company}
                                        </a>
                                      </p>
                                    </div>
                                  </div>
                                  <p className="popup-desc" dangerouslySetInnerHTML={{ __html: speaker?.description }}></p>
                                </div>
                              </div>
                            </li>
                        ))}
                  </ul>
                </div>
              </section>
          )}
          <div className="container">
            <section className="about-container" id="about">
              <h2 className="title-about title-about-single">
                About the {" "}
                {conference.conferenceType === 0 ? "conference" : "summit"}
              </h2>
              <div className="line-container">
                <span className="line-about"></span>
              </div>
              <p className="description-about add-about" dangerouslySetInnerHTML={{ __html: conference.aboutEvent }}></p>
              {/*<div className="eventPhotos">*/}
              {/*  <p className={`description-about ${conference.speakers && conference.speakers.length > 0 ? 'add-about-active' : 'add-about'}`}*/}
              {/*     dangerouslySetInnerHTML={{ __html: conference.aboutEvent }}></p>*/}
              {/*  {conference.speakers && conference.speakers.length > 0 && (*/}
              {/*      <PersonalPhotos speakers={conference.speakers} />*/}
              {/*  )}*/}
              {/*</div>*/}
              {!myEventListButtons.includes(conference.eventName) && (
                  <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap', justifyContent: 'center' }}>
                    <button className="action-button-register"
                            onClick={() => handleOpenModal("delegate")} // Добавленный onClick
                    >
                      Register now
                    </button>
                    <button className="action-button-agenda"
                            onClick={() => handleOpenModal("agenda")} // Добавленный onClick
                    >
                      Download PDF agenda
                    </button>
                  </div>
              )}
              {conference.hotelMap && conference.hotelMap.length > 0 &&(
                  <a className="popup-with-zoom-anim2" target="_blank" href={conference.hotelMap}>
                    <button className="neon-button">
                      Free Pre-Summit Teaser
                    </button>
                  </a>

              )}
              {/*<button className="register-button"><ThreeDots  height="40" width="40" color="white"  /></button>*/}
            </section>
          </div>
          {myEventVideo.includes(conference.eventName) && (
              <section className="videobox">
                <div className="playerbox">
                  <div className="player">
                    <ReactPlayer
                        url="https://lp.bcf-events.com/wp-content/uploads/2021/03/Video/Photogallery/BCF.mp4"
                        playing={false}
                        controls={true}
                        width="100%"
                        height="100%"
                        className="react-player"
                    />
                  </div>
                </div>
              </section>)}
          <section className="section-keys" id="key">
            <div className="key-container container">
              <div className="key-container-block">
                <h3 className="key-title">KEY POINTS</h3>
                <ul>
                  {conference.keyPoints?.map((point, index) => (
                      <div
                          key={point.id}
                          className={`key-block ${index > 2 && !showAll ? 'hidden' : ""}`}>
                        <img
                            src={`${keyImages[index % keyImages.length]}`}
                            alt=""
                        />
                        <li>{point.keyName}</li>
                      </div>
                  ))}
                  {conference.keyPoints?.length > 2 && (
                      <li className={`key-point-btn ${!showAll ? 'btn-hidden' : ""}`}>
                        <span onClick={() => setShowAll(!showAll)}>
                          {showAll ? <FontAwesomeIcon icon={faAngleDoubleUp} /> : <FontAwesomeIcon icon={faAngleDoubleDown} />}
                        </span>
                      </li>
                  )}
                </ul>
              </div>
              <span className="vertical-line"></span>
              <div className="mobile-line-container">
                <span className="mobile-title-line"></span>
              </div>
              <div className="key-container-block">
                <h3 className="key-title">WHO SHOULD ATTEND</h3>
                <ul>
                  {conference.attendReasons?.map((reason, index) => (
                      <div
                          key={reason.id}
                          className={`key-block ${index > 2 && !showAll ? 'hidden' : ""}`}>
                        <img
                            src={`${keyImages[index % keyImages.length]}`}
                            alt=""
                        />
                        <li>{reason.reason}</li>
                      </div>
                  ))}
                  {conference.attendReasons?.length > 2 && (
                      <li className={`key-point-btn ${!showAll ? 'btn-hidden' : ""}`}>
                        <span onClick={() => setShowAll(!showAll)}>
                          {showAll ? <FontAwesomeIcon icon={faAngleDoubleUp} /> : <FontAwesomeIcon icon={faAngleDoubleDown} />}
                        </span>
                      </li>
                  )}
                </ul>
              </div>
            </div>
            <div style={{ display: 'flex', marginTop: '25px', justifyContent: 'center' }}>
              <button className="action-button-register"
                      onClick={() => handleOpenModal("delegate")} // Добавленный onClick
              >
                Register Now
              </button>
            </div>
          </section>
          {conference.sponsors && conference.sponsors.length > 0 && (
              <section className="section-speakers" id="sponsors">
                <div className="container">
                  <h2 className="title-about title-about-single">Sponsors</h2>
                  <div className="line-container">
                    <span className="line-about"></span>
                  </div>
                  <ul className="grid-container-sponsor">
                    {conference.sponsors &&
                        conference.sponsors
                            .sort((a, b) => a.sponsorType - b.sponsorType) // Сортировка по типу спонсора
                            .map((sponsor) => (
                                <a href={sponsor.sponsorUrlLogo} key={sponsor.id} target="_blank" rel="noopener noreferrer">
                                  <li className="grid-item" key={sponsor.id} style={{ marginBottom: '-160px' }}>
                                    <div className="new-sponsors">
                                      <p className="name" style={{ fontSize: '22px' }}>{getSponsorType(sponsor.sponsorType)}</p>
                                      <img
                                          className="new-logo-sponsor"
                                          src={sponsor.sponsorLogo}
                                          alt=""
                                      />
                                    </div>
                                  </li>
                                </a>))}
                  </ul>
                </div>
                <div style={{ display: 'flex', marginTop: '25px', justifyContent: 'center' }}>
                  <Link className="popup-with-zoom-anim2" to="/secondsponsorship">
                    <button className="action-button-register"
                            onClick={() => handleOpenModal("delegate")} // Добавленный onClick
                    >
                      Become a sponsor
                    </button>
                  </Link>
                </div>
              </section>
          )}
          {/*{conference.sponsors && conference.sponsors.length > 0 && (*/}
          {/*    <section className="section-sponsors">*/}
          {/*      <div className="container">*/}
          {/*        <div className="sponsors-wrapper">*/}
          {/*          {conference.sponsors.some(sponsor => sponsor.sponsorType === 0) && (*/}
          {/*              <div className="price-sponsors-container custom-sponsors">*/}
          {/*                <h3 className="price-sponsors">*/}
          {/*                  {conference.sponsors.some(sponsor => sponsor.sponsorType === 0) ? (*/}
          {/*                      conference.sponsors.filter(sponsor => sponsor.sponsorType === 0).length > 1 ? (*/}
          {/*                          'Diamond Sponsors'*/}
          {/*                      ) : (*/}
          {/*                          'Diamond Sponsor'*/}
          {/*                      )*/}
          {/*                  ) : null}*/}
          {/*                </h3>*/}
          {/*                <div className="line-container">*/}
          {/*                  <span className="line-about"></span>*/}
          {/*                </div>*/}
          {/*                <div className="sponsors-image">*/}
          {/*                {conference.sponsors*/}
          {/*                    .filter(sponsor => sponsor.sponsorType === 0)*/}
          {/*                    .map((sponsor, index) => (*/}
          {/*                      <a href={sponsor.sponsorUrlLogo} key={sponsor.id} target="_blank" rel="noopener noreferrer">*/}
          {/*                        <img*/}
          {/*                            src={sponsor.sponsorLogo}*/}
          {/*                            className="sponsor-image"*/}
          {/*                            key={sponsor.id}*/}
          {/*                        />*/}
          {/*                        </a>))}*/}
          {/*                </div>*/}
          {/*              </div>*/}
          {/*          )}*/}
          {/*          {conference.sponsors.some(sponsor => sponsor.sponsorType === 1) && (*/}
          {/*              <div className="price-sponsors-container custom-sponsors">*/}
          {/*                <h3 className="price-sponsors">*/}
          {/*                  {conference.sponsors.some(sponsor => sponsor.sponsorType === 1) ? (*/}
          {/*                      conference.sponsors.filter(sponsor => sponsor.sponsorType === 1).length > 1 ? (*/}
          {/*                          'Platinum Sponsors'*/}
          {/*                      ) : (*/}
          {/*                          'Platinum Sponsor'*/}
          {/*                      )*/}
          {/*                  ) : null}*/}
          {/*                </h3>*/}
          {/*                <div className="line-container">*/}
          {/*                  <span className="line-about"></span>*/}
          {/*                </div>*/}
          {/*                <div className="sponsors-image">*/}
          {/*                {conference.sponsors*/}
          {/*                    .filter(sponsor => sponsor.sponsorType === 1)*/}
          {/*                    .map((sponsor, index) => (*/}

          {/*                      <a href={sponsor.sponsorUrlLogo} key={sponsor.id} target="_blank" rel="noopener noreferrer">*/}
          {/*                        <img*/}
          {/*                            src={sponsor.sponsorLogo}*/}
          {/*                            className="sponsor-image"*/}
          {/*                            key={sponsor.id}*/}
          {/*                        />*/}
          {/*                        </a> ))}*/}
          {/*                </div>*/}

          {/*              </div>*/}
          {/*          )}*/}
          {/*          {conference.sponsors.some(sponsor => sponsor.sponsorType === 2) && (*/}
          {/*              <div className="price-sponsors-container custom-sponsors">*/}
          {/*                <h3 className="price-sponsors">*/}
          {/*                  {conference.sponsors.some(sponsor => sponsor.sponsorType === 2) ? (*/}
          {/*                      conference.sponsors.filter(sponsor => sponsor.sponsorType === 2).length > 1 ? (*/}
          {/*                          'Gold Sponsors'*/}
          {/*                      ) : (*/}
          {/*                          'Gold Sponsor'*/}
          {/*                      )*/}
          {/*                  ) : null}*/}
          {/*                </h3>*/}
          {/*                <div className="line-container">*/}
          {/*                  <span className="line-about"></span>*/}
          {/*                </div>*/}
          {/*                <div className="sponsors-wrapper">*/}
          {/*                  <div className="sponsors-image">*/}
          {/*                  {conference.sponsors*/}
          {/*                      .filter(sponsor => sponsor.sponsorType === 2)*/}
          {/*                      .map((sponsor, index) => (*/}
          {/*                        <a href={sponsor.sponsorUrlLogo} key={sponsor.id} target="_blank" rel="noopener noreferrer">*/}
          {/*                          <img*/}
          {/*                              src={sponsor.sponsorLogo}*/}
          {/*                              className="sponsor-image"*/}
          {/*                              key={sponsor.id}*/}
          {/*                          />*/}
          {/*                          </a>))}*/}
          {/*                  </div>*/}
          {/*                </div>*/}
          {/*              </div>*/}
          {/*          )}*/}
          {/*          {conference.sponsors.some(sponsor => sponsor.sponsorType === 3) && (*/}
          {/*              <div className="price-sponsors-container custom-sponsors">*/}
          {/*                <div className="price-sponsors-container">*/}
          {/*                  <h3 className="price-sponsors">*/}
          {/*                    {conference.sponsors.some(sponsor => sponsor.sponsorType === 3) ? (*/}
          {/*                        conference.sponsors.filter(sponsor => sponsor.sponsorType === 3).length > 1 ? (*/}
          {/*                            'Silver Sponsors'*/}
          {/*                        ) : (*/}
          {/*                            'Silver Sponsor'*/}
          {/*                        )*/}
          {/*                    ) : null}*/}
          {/*                  </h3>*/}
          {/*                  <div className="line-container">*/}
          {/*                    <span className="line-about"></span>*/}
          {/*                  </div>*/}
          {/*                  <div className="sponsors-image">*/}
          {/*                  {conference.sponsors*/}
          {/*                      .filter(sponsor => sponsor.sponsorType === 3)*/}
          {/*                      .map((sponsor, index) => (*/}
          {/*                        <a href={sponsor.sponsorUrlLogo} key={sponsor.id} target="_blank" rel="noopener noreferrer">*/}
          {/*                          <img*/}
          {/*                              key={sponsor.id}*/}
          {/*                              src={sponsor.sponsorLogo}*/}
          {/*                              className="sponsor-image"*/}
          {/*                          />*/}
          {/*                          </a>))}*/}
          {/*                  </div>*/}
          {/*                </div>*/}
          {/*              </div>*/}
          {/*          )}*/}
          {/*          {conference.sponsors.some(sponsor => sponsor.sponsorType === 6) && (*/}
          {/*              <div className="price-sponsors-container custom-sponsors">*/}
          {/*                <div className="price-sponsors-container">*/}
          {/*                  <h3 className="price-sponsors">*/}
          {/*                    {conference.sponsors.some(sponsor => sponsor.sponsorType === 6) ? (*/}
          {/*                        conference.sponsors.filter(sponsor => sponsor.sponsorType === 6).length > 1 ? (*/}
          {/*                            'Online Silver Sponsors'*/}
          {/*                        ) : (*/}
          {/*                            'Online Silver Sponsor'*/}
          {/*                        )*/}
          {/*                    ) : null}*/}
          {/*                  </h3>*/}
          {/*                  <div className="line-container">*/}
          {/*                    <span className="line-about"></span>*/}
          {/*                  </div>*/}
          {/*                  <div className="sponsors-image">*/}
          {/*                    {conference.sponsors*/}
          {/*                        .filter(sponsor => sponsor.sponsorType === 6)*/}
          {/*                        .map((sponsor, index) => (*/}
          {/*                            <a href={sponsor.sponsorUrlLogo} key={sponsor.id} target="_blank" rel="noopener noreferrer">*/}
          {/*                              <img*/}
          {/*                                  key={sponsor.id}*/}
          {/*                                  src={sponsor.sponsorLogo}*/}
          {/*                                  className="sponsor-image"*/}
          {/*                              />*/}
          {/*                            </a>))}*/}
          {/*                  </div>*/}
          {/*                </div>*/}
          {/*              </div>*/}
          {/*          )}*/}
          {/*          {conference.sponsors.some(sponsor => sponsor.sponsorType === 4) && (*/}
          {/*              <div className="price-sponsors-container custom-sponsors">*/}
          {/*                <div className="price-sponsors-container">*/}
          {/*                  <h3 className="price-sponsors">*/}
          {/*                    {conference.sponsors.some(sponsor => sponsor.sponsorType === 4) ? (*/}
          {/*                        conference.sponsors.filter(sponsor => sponsor.sponsorType === 4).length > 1 ? (*/}
          {/*                            'Keynote Sponsors'*/}
          {/*                        ) : (*/}
          {/*                            'Keynote Sponsor'*/}
          {/*                        )*/}
          {/*                    ) : null}*/}
          {/*                  </h3>*/}
          {/*                  <div className="line-container">*/}
          {/*                    <span className="line-about"></span>*/}
          {/*                  </div>*/}
          {/*                  <div className="sponsors-image">*/}
          {/*                  {conference.sponsors*/}
          {/*                      .filter(sponsor => sponsor.sponsorType === 4)*/}
          {/*                      .map((sponsor, index) => (*/}
          {/*                        <a href={sponsor.sponsorUrlLogo} key={sponsor.id} target="_blank" rel="noopener noreferrer">*/}
          {/*                          <img*/}
          {/*                              key={sponsor.id}*/}
          {/*                              src={sponsor.sponsorLogo}*/}
          {/*                              className="sponsor-image"*/}
          {/*                          />*/}
          {/*                          </a>))}*/}
          {/*                  </div>*/}
          {/*                </div>*/}
          {/*              </div>*/}
          {/*          )}*/}
          {/*          {conference.sponsors.some(sponsor => sponsor.sponsorType === 5) && (*/}
          {/*              <div className="price-sponsors-container custom-sponsors">*/}
          {/*                <div className="price-sponsors-container">*/}
          {/*                  <h3 className="price-sponsors">*/}
          {/*                    {conference.sponsors.some(sponsor => sponsor.sponsorType === 5) ? (*/}
          {/*                        conference.sponsors.filter(sponsor => sponsor.sponsorType === 5).length > 1 ? (*/}
          {/*                            'Exhibition Sponsors'*/}
          {/*                        ) : (*/}
          {/*                            'Exhibition Sponsor'*/}
          {/*                        )*/}
          {/*                    ) : null}*/}
          {/*                  </h3>*/}
          {/*                  <div className="line-container">*/}
          {/*                    <span className="line-about"></span>*/}
          {/*                  </div>*/}
          {/*                  <div className="sponsors-image">*/}
          {/*                  {conference.sponsors*/}
          {/*                      .filter(sponsor => sponsor.sponsorType === 5)*/}
          {/*                      .map((sponsor, index) => (*/}
          {/*                          <a href={sponsor.sponsorUrlLogo} key={sponsor.id} target="_blank" rel="noopener noreferrer">*/}
          {/*                            <img*/}
          {/*                                key={sponsor.id}*/}
          {/*                                src={sponsor.sponsorLogo}*/}
          {/*                                className="sponsor-image"*/}
          {/*                            />*/}
          {/*                          </a>))}*/}
          {/*                  </div>*/}
          {/*                </div>*/}
          {/*              </div>*/}
          {/*          )}*/}
          {/*        </div>*/}
          {/*      </div>*/}
          {/*    </section>*/}
          {/*)}*/}
          <section className="section-gallery" id="gallery">
            <div className="container">
              <h2 className="title-gallery title-about-single">Gallery</h2>
              <div className="line-container">
                <span className="line-about"></span>
              </div>
              <span className="opacity-gallery">124</span>
            </div>
            <Swiper
                id="mainSwiper"
                ref={(swiper) => (swiperRef.current = swiper)}
                spaceBetween={10}
                centeredSlides={true}
                initialSlide={3}
                navigation={{
                  nextEl: '.right-arrow',
                  prevEl: '.left-arrow',
                }}
                breakpoints={{
                  319: {
                    slidesPerView: 3
                  },
                  767: {
                    slidesPerView: 5
                  }
                }}
            >
              {galleryImages.map((image, index) => (
                  <React.Fragment>
                    <SwiperSlide key={image} onClick={() => handleImageClick(index)}>
                      <div
                          className="slide-swiper"
                          key={image}
                          style={{
                            backgroundImage: `url(${image})`,
                          }}
                      ></div>
                    </SwiperSlide>
                  </React.Fragment>
              ))}
            </Swiper>
            <div className="arrow-container home-arrow-container single-arrow-container">
              {/*<div className="left-arrow" id="btnPrev2"></div>*/}
              {/*<div className="right-arrow" id="btnNext2"></div>*/}
            </div>

          </section>
          {conference.partners && conference.partners.length > 0 && (
              <section name="partners" className="partners-block">
                <div className="container">
                  <h2 className="title-about title-about-single">Our partners</h2>
                  <div className="line-container">
                    <span className="line-about"></span>
                  </div>

                  <Swiper
                      id="partnersSwiper"
                      ref={(swiper) => (swiperRef.current = swiper)}
                      spaceBetween={10}
                      centeredSlides={true}
                      className="partners-list"
                      navigation={{
                        nextEl: '.right-arrow-partners',
                        prevEl: '.left-arrow-partners',
                      }}
                      breakpoints={{
                        319: {
                          slidesPerView: 3,
                          centeredSlides: true,
                          initialSlide: 6
                        },
                        767: {
                          slidesPerView: 3,
                          centeredSlides: true,
                          spaceBetween: 5,
                          initialSlide: 6
                        },
                        1023: {
                          slidesPerView: 5,
                          centeredSlides: true,
                          initialSlide: 6
                        }

                      }}

                      onSlideChange={(swiper) => {
                        setActiveSlide(swiper.activeIndex);
                        console.log("Active Slide Index:", swiper.activeIndex);
                        console.log("Prev Slide Index:", swiper.prevIndex);
                        console.log("Next Slide Index:", swiper.nextIndex);

                      }}>
                    {conference.partners?.map((partner, index) => (
                        <React.Fragment key={partner.id}>
                          <SwiperSlide onClick={() => handleImageClickpartner(index)}>
                            <a href={getPartnerUrl(partner, conference.eventName)} target="_blank" rel="noopener noreferrer">
                              <li className="your-existing-li-class" style={{ opacity: activeSlide === index ? 1 : 0.5 }}>
                                <img src={partner.partnerLogo} alt={partner.partnerName}/>
                              </li>
                            </a>
                          </SwiperSlide>
                        </React.Fragment>
                    ))}

                  </Swiper>
                  <div className="arrow-container home-arrow-container single-arrow-container">
                    {/*<div className="right-arrow-partners" id="btnNext2"></div>*/}
                    {/*<div className="left-arrow-partners" id="btnPrev2"></div>*/}
                  </div>
                </div>
              </section>
          )}
          {conference.hotels && conference.hotels.length > 0 && (
              <section className="venue-section" id="venue">
                <div className="container" style={{ marginBottom: '25px' }}>
                  <h2 className="title-gallery">Venue</h2>
                  <div className="line-container">
                    <span className="line-about"></span>
                  </div>
                  {conference?.hotels?.map((hotel) => (
                      <div key={hotel.id}>
                      <span>
                        <h3 className="venue-title">
                          {hotel.hotelName}
                          <br/>
                          {myEventDescription.includes(conference.eventName) && (
                              <span style={{ fontSize: 'medium', color: 'lightblue' }}>
                             Book with us and get a discounted price. Contact us at: {" "}
                                <a href={`mailto: general@bcf-events.com`} style={{ textDecoration: "underline" }}>
                                  general@bcf-events.com
                                      </a>
                              </span>
                          )}
                          </h3>
                         <p className="venue-description">
                          <span className="address-line">{hotel.hotelAddress}</span>
                           {/*<span className="blue-line"></span>*/}
                           {/*     <button onClick={() => window.open(conference.hotelMap, '_blank')} */}
                           {/*             target="_blank" className="how-to-get-button">How to get</button>*/}
                         </p>
                      </span>
                        {conference.hotelBookingUrl && conference.hotelBookingUrl.length > 0  && (
                            <div className="btn-wrapper">
                              <button onClick={() => window.open(conference.hotelBookingUrl, '_blank')} target="_blank" className="venue-btn">Book a room</button>
                            </div>)}
                      </div>))}
                  <span className="opacity-gallery">124</span>
                </div>
                <Swiper
                    id="hotelSwiper"
                    ref={(swiper) => (swiperRef.current = swiper)}
                    initialSlide={3}
                    spaceBetween={10}
                    centeredSlides={true}
                    navigation={{
                      nextEl: '.right-arrow-venue',
                      prevEl: '.left-arrow-venue',
                    }}
                    breakpoints={{
                      319: {
                        slidesPerView: 3
                      },
                      767: {
                        slidesPerView: 5
                      }
                    }}
                >
                  {hotelImages.map((image, index) => (
                      <React.Fragment>
                        <SwiperSlide key={image} onClick={() => handleImageClickhotel(index)}>
                          <div
                              className="slide-swiper"
                              key={image}
                              style={{
                                backgroundImage: `url(${image})`,
                              }}
                          ></div>
                        </SwiperSlide>
                      </React.Fragment>
                  ))}
                </Swiper>
                <div className="arrow-container home-arrow-container single-arrow-container">
                  {/*<div className="left-arrow-venue" id="btnPrev"></div>*/}
                  {/*<div className="right-arrow-venue" id="btnNext"></div>*/}
                </div>
              </section>
          )}
          {conference.employees && conference.employees.length > 0 && (
              <section name="employees" className="employees-block" id="contact">
                <div className="container">
                  <h2 className="title-about title-about-single">Contact us</h2>
                  <div className="line-container">
                    <span className="line-about"></span>
                  </div>
                  <div>
                    <ul className="contact-list">
                      {conference.employees?.map((employee) => (
                          <li key={employee.id}>
                            <h2>{employee.callToAction}</h2>
                            <img width="150px" src={employee.photo} alt="" />
                            <h3>{employee.fullName}</h3>
                            <h4>{employee.position}</h4>
                            <p className="phone">{employee.phone}</p>
                            <p className="email"><a  className="employee-mailto" href={`mailto:${employee.email}`}>{employee.email}</a></p>
                          </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </section>
          )}
        </main>
        <Footer />
      </div>
  );
}
//ещё
export default SingleConference;